import { DrugIcd, Prescription, RenderMedia } from '@fusion-advantage/backcompat'
import { generateDrugIcdDataSet } from "@fusion-advantage/formlib"
import L3MedicationReconciliationTable, { L3MedicationReconciliationReadOnlyTable } from "../l3/L3MedicationReconciliationTable"
import { useCallback, useEffect } from "react"
import _ from 'lodash'
import { useFormDispatch, useFormSelector } from "../../../redux/formStoreHooks"
import { loadDrugIcdDataSet, setPrescriptions } from "../../../redux/drugSlice"
import { selectAllIcd10s, selectMedReconSorted } from "../../../redux/selectMedicationReconciliation"
import { useFormAppRelay } from "../../../lib/relay/FormAppRelay"

const L4MedicationReconciliationTable = () => {
	const dispatch = useFormDispatch()
	const models = useFormSelector(selectMedReconSorted)
	const icds = useFormSelector(selectAllIcd10s)
	const icdCodes = useFormSelector(state => state.formModel.drugIcd)
	const { selectDrugIcdCodes } = useFormAppRelay()
	const icdDataSet = useFormSelector(state => state.drug.icdCodeDataSet)
	const media = useFormSelector(state => state.render.media)

	const handleChange = useCallback((newModels: Prescription[]) => {
		dispatch(setPrescriptions(newModels))
	}, [dispatch])

	useEffect(() => {
		const buildDataSetAsync = async () => {
			const {priorIcd10s, supportedIcd10s} = icds

			const dataSet = generateDrugIcdDataSet(icdCodes, priorIcd10s, supportedIcd10s)

			dispatch(loadDrugIcdDataSet(dataSet))
		}

		buildDataSetAsync()
	}, [])

	const loadProductCodes = useCallback(async (productId: number): Promise<DrugIcd[]> => {
		const { icdCodes } = await selectDrugIcdCodes({productId})
		return icdCodes
	}, [])

	return (
		media === RenderMedia.Print ? (
			<L3MedicationReconciliationReadOnlyTable 
				models={models}
			/>
		) : (
			<L3MedicationReconciliationTable
				handleLoadProductCodes={loadProductCodes}
				models={models}
				onChange={handleChange}
				icdDataSet={icdDataSet}
			/>
		)
	)
}

export default L4MedicationReconciliationTable